<div class="p-grid p-align-start vertical-container mt-1 container-fullsize">
    <!-- <div class="col-md-12 text-center" style="margin-bottom:-30px;">
        <img *ngIf="logo != null"  src="{{logo}}" class="logo" alt="Responsive image">
    </div> -->
    <div class="p-col-12  p-col-align-start  " id= "tableresultados">
        <div class="box text-center shadow-lg p-2 mb-2 bg-white rounded" style="min-height: 450px !important;">
            <div class=" mx-3 text-left">
                <span class=" mx-4 text-center font-weight-bolder text-success shadow">
                    <h2> Resultado Eleição {{resultadosEleicao?.titulo}}
                    <br>
                    <small>( {{resultadosEleicao?.dataInicio | date: 'dd/MM/yyyy HH:mm':'GMT'}} até {{resultadosEleicao?.dataFim | date: 'dd/MM/yyyy HH:mm':'GMT'}} )</small></h2>
                  </span >
                </div>
                <div class="mx-2 text-right" *ngIf="!ehEleitor">
                    <button class="btn btn-outline-secondary mx-3" (click)="exportVotantesParaExcel()" pTooltip="Baixar planilha de eleitores votantes">
                        <i class="fas fa-file-download"></i>
                    </button>
                    <button class="btn btn-outline-secondary" (click)="exportParaExcel()" pTooltip="Salvar planilha de resultados da eleição">
                        <i class="fas fa-save"></i>
                    </button>
                </div>
            <div class="table-responsive">
                <ul *ngFor="let p of listaPlanosFiltrada" class="px-3">
                    <h4 class="mb-4" *ngIf="p !=null  && p!= ''" >Votação <span *ngIf="p != null || p !='GERAL'"> {{p.toUpperCase()}}</span></h4>
                <table class="table table-fixed table-bordered"  *ngIf="p !=null  && p!= ''">           
                    <thead>
                        <tr>
                            <th scope="col" style="width:20%">Cargo</th>
                            <th scope="col" style="width:10%">Nº de Votos por Eleitor</th>
                            <th scope="col" style="width:20%">Candidato/Chapa</th>
                            <th scope="col" style="width:20%">Quantidade de votos</th>
                            <th scope="col" style="width:20%" *ngIf="p !=null && p !='GERAL'  && p!= ''">Plano</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let res of resultados" [ngClass]="res.candidatoNome == 'Nulo' || res.candidatoNome == 'Branco' ? 'bntpo' : '' ">
                            <td *ngIf="res.plano == p">{{res.candidatoCargo}}</td>
                            <td *ngIf="res.plano == p">{{res.qtdElegiveis}}</td>
                            <td *ngIf="res.plano == p" class="wrap-td">
                                <span class="preline">{{ res.candidatoNome }}</span></td>
                            <td *ngIf="res.plano == p" >{{res.numVotos}}</td>
                            <td *ngIf="res.plano == p  && (res.plano !=null  && p !='GERAL' && p!= '')">{{res.plano}}</td>
                        </tr>
                    </tbody>
                </table>
                <hr>
                <div class="mx-3 text-left" *ngIf="p !=null  && p!=''">
                    <p>Total de votos: {{somaTotalPorPlano(p)}} </p>
                </div>
                </ul>
            </div>
        </div>
    </div>
</div>